<template>

    <div
        class="wrapperForm"
    >
        <v-row 
            no-gutters
        >

            <v-col cols="12" sm="12" md="12" class="section-wrapper">
                <v-card 
                    flat
                >
                    <v-card-text>

                        <div class="form-box-title title-with-right-part">
                            <span>
                                {{ $t("Журналы_регистрации") }}
                            </span>
                            <div class="twrp-content">
                                <v-text-field
                                    :value="search"
                                    @input="updateSearch($event)"
                                    :placeholder="$t('Поиск')"
                                    hide-details
                                    dense
                                    clearable
                                    required
                                    @click:clear="search=''"
                                    class="twrp-search"
                                    append-icon="fas fa-search"
                                >
                                </v-text-field>
                            </div>
                        </div>

                        <div class="d-flex" v-if="years.length>0">
                            <div class="status-panel-into-section-after-title-label">{{ $t('Год') }}</div>
                            <div class="status-panel status-panel-into-section-after-title">
                                <v-chip-group
                                    v-model="year"
                                    active-class="active-panel-item"
                                    mandatory
                                >
                                    <v-chip
                                        v-for="(item, index) in years"
                                        :key="index"
                                        :value="item"
                                        class="ma-1"
                                        small
                                        label
                                    >
                                        {{ item }}
                                    </v-chip>
                                </v-chip-group>
                            </div> 
                        </div>

                        <v-data-table
                            :loading="loading"
                            :headers="headers"
                            :items="entities"
                            :options.sync="options"
                            :server-items-length="total"
                            :items-per-page="10"
                            :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
                            :page.sync="options.page"
                            @page-count="paginationPageCount = $event"
                            class="elevation-1 customization-list-table pagination-list-table sticky-table"
                            @dblclick:row="(event, data) => onRowClick({ id: data.item.id })"
                        >

                            <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                            <template v-slot:[`item.name`]="{ item }">
                                <div class="elipsis-text-wrap">
                                    <div class="etw-text-container">
                                        <div class="etw-text" v-tooltip.top-center="item.name">
                                            {{item.name}}
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:[`item.reserve`]="{ item }">
                                <div class="elipsis-text-wrap">
                                    <div class="etw-text-container">
                                        <div class="etw-text" v-tooltip.top-center="item.reserve">
                                            {{item.reserve}}
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:[`footer.prepend`]>
                                <v-pagination
                                    v-model="options.page"
                                    :length="paginationPageCount"
                                    :total-visible="$listPaginationTotal"
                                    color="teal"
                                ></v-pagination>
                            </template>

                        </v-data-table>

                    </v-card-text>
                </v-card>
            </v-col>

        </v-row>        
    </div>

</template>

<script>
import i18n from '@/i18n';
import _ from 'lodash';
import { httpAPI } from "@/api/httpAPI";
import { mapActions } from 'vuex';

export default {
    name: "ChancelleryCounters",
    columnIndex: {
        'year': 2, 
        'name': 3,
        'value': 4, 
        'registrationplace': 5, 
        'reserve': 6
    },
    props: {
        enterpriseId: {
            type: String,
            default: null
        }
    },
    asyncComputed: {
        years: {
            async get() {
                let response = await httpAPI({
                    url: `api/settings/filter?collection=Chancellery.Counter&entid=${this.enterpriseId}`,
                    method: 'GET'
                });

                let years = response?.data.payload?.Years?.filter(x => x[0] !== 'Все').map(x => parseInt(x[0])) ?? [];
                return _(years).sortBy().value().reverse();
            },
            default: [],
            lazy: true
        }
    },
    computed: {
        filter() {
            return {
                ...this.options,
                SearchStr: this.search,
                Year : this.year
            }
        }
    },
    data: () => ({
        headers: [
            { text: i18n.t("Год"), value: 'year', width: '150px' },
            { text: i18n.t("Наименование"), value: 'name' },
            { text: i18n.t("Счетчик"), value: 'value', width: '10%' },
            { text: i18n.t("Резерв"), value: 'reserve', width: '10%'}
        ],
        loading: false,
        total: 0,
        entities: [],
        search: '',
        year: null,
        options: {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "year" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
        paginationPageCount: 0
    }),
    methods: {
        ...mapActions(['setOverlayVisible']),
        async onRowClick(eventData) {
            try
            {
                this.setOverlayVisible({ visible: true });
                await this.$router.push({ name: 'Counter', query: { id: eventData.id }, params: { id: eventData.id, enterpriseId: this.enterpriseId } });
            }
            catch (err)
            {
                console.warn(err);
            }
            finally
            {
                this.setOverlayVisible({ visible: false });
            }
        },
        updateSearch: _.debounce(function(v) {
            if (v !== null)
                this.search = v;
        }, 500),
        async getData() {
            this.total = 0;
            this.entities = [];
            this.loading = true;

            let response = await httpAPI({
                url: `api/settings/list?collection=Chancellery.Counter&entid=${this.enterpriseId}&filter=${JSON.stringify(this.getTableFilterObject())}`,
                method: 'GET'
            });

            this.entities = response?.data?.payload?.data ?? [];
            this.total = response?.data?.payload?.total ?? 0;
            this.loading = false;
        },
        getTableFilterObject() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr, Year } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "year" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn] ?? 2;

            return {
                SearchStr,
                Year: Year === "All" ? "": Year,
                OrderBy,
                OrderDir,
                Limit: itemsPerPage,
                Offset: (page - 1) * itemsPerPage
            };
        }
    },
    watch: {
        filter: {
            async handler(newVal, oldVal) {
                if (!this.$_.isEqual(newVal, oldVal)) {
                    console.log('filter changed');
                    await this.getData();
                }
            },
            deep: true,
        },
    }
}
</script>